import { SVGProps } from "react";

const TransparentCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="#1A1C1F"
      fillRule="evenodd"
      d="M8 0C3.587 0 0 3.587 0 8s3.587 8 8 8 8-3.587 8-8-3.587-8-8-8M1.19 8A6.82 6.82 0 0 1 8 1.19 6.82 6.82 0 0 1 14.81 8 6.82 6.82 0 0 1 8 14.81 6.82 6.82 0 0 1 1.19 8"
      clipRule="evenodd"
    ></path>
    <path
      fill="#1A1C1F"
      d="M11.568 5.476a.6.6 0 0 0-.841 0L6.949 9.254 5.274 7.58a.6.6 0 0 0-.842 0c-.23.23-.23.611 0 .842l2.096 2.095a.595.595 0 0 0 .841 0l4.199-4.198c.23-.23.23-.611 0-.842"
    ></path>
  </svg>
);
export default TransparentCheck;
